/* ROADNEST — legal & policy pages.
   Builds the sticky chapter rail from the document's own h2s. Progressive
   enhancement: if anything here fails the page stays a single readable column.
   Shopify's /policies/* markup cannot be edited, so the rail is created here
   and the layout wrapper is inserted around the existing content. */
(function () {
  'use strict';

  var content =
    document.querySelector('.rn-legal__content') ||
    document.querySelector('.shopify-policy__body');
  if (!content) return;

  var headings = Array.prototype.filter.call(
    content.querySelectorAll('h2'),
    function (h) { return (h.textContent || '').trim().length > 0; }
  );
  // A rail is only worth its space once there are enough sections to navigate.
  if (headings.length < 3) return;

  function slugify(text, index) {
    var base = (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base ? 'sec-' + base.slice(0, 48) : 'sec-' + (index + 1);
  }

  var used = Object.create(null);
  var nav = document.createElement('nav');
  nav.className = 'rn-legal-toc';
  nav.setAttribute('aria-label', 'Sommaire');

  var label = document.createElement('p');
  label.className = 'rn-legal-toc__label';
  label.textContent = 'Sommaire';
  nav.appendChild(label);

  var list = document.createElement('ol');
  var links = [];

  headings.forEach(function (heading, i) {
    var id = heading.id;
    if (!id) {
      id = slugify(heading.textContent, i);
      while (used[id] || document.getElementById(id)) id = id + '-' + (i + 1);
      heading.id = id;
    }
    used[id] = true;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = (heading.textContent || '').trim();
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });

  nav.appendChild(list);

  var mobileNav = document.createElement('details');
  mobileNav.className = 'rn-legal-mobile-toc';
  var mobileSummary = document.createElement('summary');
  mobileSummary.textContent = 'Sommaire';
  mobileNav.appendChild(mobileSummary);
  var mobileList = list.cloneNode(true);
  mobileNav.appendChild(mobileList);

  // Wrap content + rail in the grid without moving the content node's contents.
  var parent = content.parentNode;
  if (!parent) return;
  parent.insertBefore(mobileNav, content);
  var layout = document.createElement('div');
  layout.className = 'rn-legal__layout';
  parent.insertBefore(layout, content);
  layout.appendChild(nav);
  layout.appendChild(content);

  Array.prototype.forEach.call(mobileList.querySelectorAll('a'), function (a) {
    a.addEventListener('click', function () { mobileNav.removeAttribute('open'); });
  });

  // Active-section highlighting.
  if (!('IntersectionObserver' in window)) return;

  var visible = Object.create(null);
  function setCurrent() {
    var best = null;
    headings.forEach(function (h) {
      if (visible[h.id]) {
        if (!best || h.getBoundingClientRect().top < best.getBoundingClientRect().top) best = h;
      }
    });
    links.forEach(function (a) {
      var on = best && a.getAttribute('href') === '#' + best.id;
      if (on) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      setCurrent();
    },
    { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
  );
  headings.forEach(function (h) { observer.observe(h); });
})();
